import { Paper, SwipeableDrawer } from "@mui/material";
import "./styles.css";

const CustomSwipableDrawer = ({
  open,
  setOpen,
  anchor,
  preventDefault,
  children,
  className,
}) => {
  const toggleDrawer = (open) => () => {
    if (preventDefault && !open) {
      return;
    }
    setOpen(open);
  };

  return (
    <SwipeableDrawer
      anchor={anchor}
      open={open}
      onClose={toggleDrawer(false)}
      onOpen={toggleDrawer(true)}
      transitionDuration={1000}
      className={`custom-swipable-drawer ${className}`}
      onTouchStart={(event) => {
        event.nativeEvent.defaultMuiPrevented = preventDefault;
      }}
    >
      <Paper>{children}</Paper>
    </SwipeableDrawer>
  );
};

export default CustomSwipableDrawer;
